export default __webpack_public_path__ + "static/media/rmall-project-5.a06456cf.webp";